import { createAsyncThunk } from '@reduxjs/toolkit';

import { getBackrsToken } from '@backrs_ui/grow-ui/src/utils/tokenHelpers';

const ENVIRONMENT_URL = process.env.REACT_APP_API_BASEURL;

export type ContentNuggetCompleted = Readonly<{
  id: number;
  user_id: number;
  content_nugget_id: number;
  is_completed: boolean;
  created_at: string;
  updated_at: string;
}>;

// Thunk to post a content nugget as completed
export const postContentNuggetCompleted = createAsyncThunk(
  'user/postContentNuggetCompleted',
  async (nuggetId: number, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-nugget/completedNugget`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${accessToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          nugget: { id: nuggetId },
        }),
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data;
    } catch (error) {
      return rejectWithValue(`Failed to post content nugget completion with error: ${error}`);
    }
  },
);

// Thunk to retrieve all completed content nuggets on bootstrap
export const fetchAllContentNuggetCompleted = createAsyncThunk(
  'user/fetchAllContentNuggetCompleted',
  async (_, { rejectWithValue }) => {
    const accessToken = getBackrsToken();

    if (!accessToken) {
      return rejectWithValue('No access token found');
    }

    try {
      const response = await fetch(`${ENVIRONMENT_URL}/content-nugget/completedNuggets`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();

      return data as ContentNuggetCompleted[];
    } catch (error) {
      return rejectWithValue(`Failed to fetch completed content nuggets with error: ${error}`);
    }
  },
);

export const filterCompletedNuggetIds = (payload: ContentNuggetCompleted[]): number[] => {
  const completedNuggetIds = payload.reduce<number[]>((acc, nugget) => {
    if (nugget.is_completed) {
      acc.push(nugget.content_nugget_id);
    }

    return acc;
  }, []);

  return completedNuggetIds;
};
